export default __webpack_public_path__ + "media/react/mcat/pages/dashboard/assets/education-3aea8a79f29e50e8ed3b6572b9c3e374.png";